import React, { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  // Redirect,
  // useHistory,
} from "react-router-dom";
import Admin from "layouts/Admin.js";
import RTL from "layouts/RTL.js";
import AutomatonProvider from "../src/context/automatonContext";
import GrammarProvider from "../src/context/grammarContext";
import LoadingProvider from "./context/Feedback/loadingContext";
// import Login from "../src/views/Login/Login.jsx";
import Cookie from "js-cookie";
import { useAlert } from "../src/context/Feedback/alertContext";
import Snackbar from "components/Snackbar/Snackbar";
// import { isAuthenticated } from "services/authenticated.js";
// import ErrorIcon from "@material-ui/icons/Error";
import DataService from "services/DataService";
import { useSystem } from "context/systemContext.jsx";
import AddAlert from "@material-ui/icons/AddAlert";

// import DataService from "services/DataService";

import { useUser } from "../src/context/userContext";
import UserDialog from "components/Dialogs/UserDialog";
import ChangePasswordDialog from "components/Dialogs/ChangePasswordDialog";
import Login from "views/Login/Login";
import SystemOff from "views/System/SystemOff";
// import About from "views/About/About";
// import DataService from "services/DataService";
// import Loading from "components/Loading/loading";
// import Login from "views/Login/Login";
// import "./App.css";

const PrivateRoute = ({
  component: Component,
  isAuth,
  isAlive,
  isAdmin,
  ...rest
}) => {
  if (!!isAlive == false && !!isAdmin == false && isAuth) {
    return <SystemOff />;
  } else {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuth ? (
            <Component {...props} auth={true} />
          ) : (
            <Component {...props} auth={false} />
          )
        }
      />
    );
  }
};

function App() {
  const { feedbackAlert, setAlert } = useAlert();
  const {
    setLanguage,
    isAuth,
    setIsAuth,
    setUser,
    setCredential,
    setIsAdmin,
    isAdmin,
  } = useUser();
  const { setIsAlive, isAlive } = useSystem();
  // const history = useHistory();
  // const { setUser, setLanguage, setCredential } = useUser();

  // const container = {
  //   flex: 1,
  //   height: innerHeight,
  //   width: innerWidth,
  //   backgroundColor: "#252536",
  // };

  const getNavigatorLanguage = () => {
    navigator.languages.every((e) => {
      if (e.includes("pt")) {
        setLanguage("pt");
      } else {
        setLanguage("en");
      }
    });
  };
  const checkAdmin = (data) => {
    for (let i = 0; i < data.roles.length; i++) {
      const element = data.roles[i];
      if (element.name === "ROLE_ADMIN") {
        setIsAdmin(true);
      }
    }
  };
  useEffect(() => {
    const storageToken = Cookie.get("token");
    DataService.isAlive({
      headers: {
        Authorization: storageToken,
      },
    }).then((res) => {
      setIsAlive(res.data);
      if (!res.data) {
        return <SystemOff />;
      }
    });
  }, [isAlive]);

  useEffect(() => {
    getNavigatorLanguage();
    const storageToken = Cookie.get("token");
    const storageMail = Cookie.get("userMail");
    DataService.isAlive({
      headers: {
        Authorization: storageToken,
      },
    }).then((res) => {
      setIsAlive(res.data);
      if (!res.data) {
        return <SystemOff />;
      }
    });

    DataService.getUserByEmail(storageMail, {
      headers: {
        Authorization: storageToken,
      },
    })
      .then((response) => {
        if (response.data.id !== undefined) {
          setIsAuth(true);
          setUser(response.data);
          checkAdmin(response.data);
          setCredential(storageToken);
          const dateNow = new Date();

          const date =
            dateNow.getFullYear() +
            "-" +
            String(dateNow.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(dateNow.getDate()).padStart(2, "0") +
            "T" +
            String(dateNow.getHours()).padStart(2, "0") +
            ":" +
            String(dateNow.getMinutes()).padStart(2, "0") +
            ":" +
            String(dateNow.getSeconds()).padStart(2, "0") +
            "Z";

          DataService.postLastAccess(storageMail, date, {
            headers: {
              Authorization: storageToken,
            },
          }).then((responseUser) => {
            setUser(responseUser.data);
            console.log(responseUser);
          });
        } else {
          setIsAuth(false);
          Cookie.remove("token");
          Cookie.remove("userMail");
        }
      })
      .catch(() => {
        setIsAuth(false);
        Cookie.remove("token");
        Cookie.remove("userMail");
      });
  }, []);

  return (
    <div>
      <BrowserRouter>
        <Switch>
          <LoadingProvider>
            <GrammarProvider>
              <AutomatonProvider>
                <Snackbar
                  place="tc"
                  color={feedbackAlert.color || "info"}
                  icon={feedbackAlert.icon || AddAlert}
                  close={true}
                  message={feedbackAlert.text}
                  closeNotification={() => {
                    setAlert((prev) => ({
                      ...prev,
                      active: false,
                    }));
                  }}
                />
                <UserDialog />
                <ChangePasswordDialog />
                {/* <Route path="/user" component={Admin} /> */}
                <PrivateRoute
                  isAuth={isAuth}
                  isAlive={isAlive}
                  isAdmin={isAdmin}
                  path="/user"
                  component={Admin}
                />
                <PrivateRoute
                  exact
                  isAuth={isAuth}
                  isAlive={isAlive}
                  isAdmin={isAdmin}
                  path="/"
                  component={Admin}
                />
                <Route exact path="/login" component={Login} />

                {/* <Route path="/about" component={About} /> */}
                {/* <Route path="/login" component={Login} /> */}
                <Route path="/rtl" component={RTL} />
                {/* <Redirect from="/" to="/login" /> */}
              </AutomatonProvider>
            </GrammarProvider>
          </LoadingProvider>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
